<script lang="ts" setup>
	import { useI18n } from 'vue-i18n'
	import { RouterLink, useRoute, useRouter } from 'vue-router'
	import { computed } from 'vue'
	import { useAuthStore } from '@/stores/auth.store'
	import IconMapper from '@/components/layout/IconMapper.vue'
	import MegaNav from '@/components/layout/MegaNav.vue'
	import { _translations } from './_translations'

	const { t } = useI18n(_translations)

	const router = useRouter()
	const authStore = useAuthStore()

	const routes = computed(() => {
		const result: any = {}
		router.options.routes.forEach((el: any) => {
			if (el.meta.group) {
				const allowedRoles: string[] = el.meta?.allowedRoles || []
				const item = { name: el.name, path: el.path, icon: el.meta.icon || null }
				if (allowedRoles.includes(authStore.role)) {
					if (!result[el.meta.group]) result[el.meta.group] = []
					result[el.meta.group].push(item)
				}
			}
		})
		return result
	})
</script>

<template>
	<ul class="rev-menu h-full w-full overflow-y-auto pb-24">
		<!-- <ul class="h-full w-full overflow-y-auto rev-menu" id="sidebar-menu"> -->
		<!-- //? GENERAL ROUTES -->
		<!-- <li class="sidebar-menu-title">{{ t('sidebar.superAdmin') }}</li> -->
		<li class="rev-menu-title">{{ t('menu.base') }}</li>
		<template v-for="(routeItem, key) in routes" :key="key">
			<li class="py-2">
				<div class="group collapse-open collapse">
					<!-- <input aria-label="Sidemenu item trigger" class="peer" type="checkbox" checked /> -->
					<div class="collapse-title flex items-center justify-between">
						<IconMapper :icon="routeItem[0].icon" />
						{{ t(`menu.${key}`) || '-' }}
						<span class="grow"></span>
						<!-- <ChevronRight class="arrow-icon" :size="iconSize" :weight="iconWeight" /> -->
					</div>

					<ul class="collapse-content">
						<li v-for="route in routeItem" :key="route.path || route.name">
							<RouterLink class="rev-menu-item" active-class="active" v-if="route.path" :to="route.path">
								<IconMapper :icon="route.icon" />
								{{ t(`menu.${route.name}`) }}
							</RouterLink>
						</li>
					</ul>
				</div>
			</li>
		</template>

		<li>
			<MegaNav />
		</li>
	</ul>
</template>

<style scoped>
	@reference '@/styles/tailwind.css';

	/* .router-link-active { */
	.active.router-link-exact-active.rev-menu-item {
		@apply glass bg-primary/10;
	}
</style>
